import { createCustomEvent } from './custom-ng-elements/utils';
import { lazyWebComponent } from './lazy-web-component';
export function createNgComponentFactory(Component, injector) {
    return { Component, injector };
}
export function lazyNgComponent(loadNgFactoryStrategy, schema) {
    async function loadNgFactoryComponent() {
        await AppRegistry.import(['@angular9', 'rxjs']); // TODO import all deps
        await AppRegistry.require('@uxanalytics/core').AppContextFactory.wait();
        const { Component, injector } = await loadNgFactoryStrategy();
        const { ComponentNgElementStrategyFactory } = await import('./custom-ng-elements/component-factory-strategy');
        const ngFactoryStrategy = new ComponentNgElementStrategyFactory(Component, injector);
        return (customElement) => {
            const ngElement = ngFactoryStrategy.create();
            let ngElementEventsSubscription;
            function mount() {
                ngElement.connect(customElement);
                ngElementEventsSubscription = ngElement.events.subscribe(e => {
                    const customEvent = createCustomEvent(customElement.ownerDocument, e.name, e.value);
                    customElement.dispatchEvent(customEvent);
                });
            }
            function unmount() {
                ngElement.disconnect();
                if (ngElementEventsSubscription) {
                    ngElementEventsSubscription.unsubscribe();
                    ngElementEventsSubscription = null;
                }
            }
            function call(prop, args) {
                return ngElement.componentRef._component[prop](...args);
            }
            Object.assign(customElement, { ngElement });
            return {
                mount,
                unmount,
                adopted: () => { },
                call,
                get: prop => ngElement.getInputValue(prop),
                set: props => {
                    for (const prop in props) {
                        ngElement.setInputValue(prop, props[prop]);
                    }
                },
            };
        };
    }
    return lazyWebComponent(loadNgFactoryComponent, { ...schema, shadowRoot: false });
}
